import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import PusherAuth from 'pusher-js-auth';

const ECHO_INSTANCE_KEY = '__ALDERON_ECHO__';

export function configureAlderonEcho(reverb) {
    if ('undefined' === typeof window || true !== reverb?.enabled) {
        return;
    }

    if (window[ECHO_INSTANCE_KEY]) {
        return;
    }

    window[ECHO_INSTANCE_KEY] = new Echo({
        broadcaster: 'reverb',
        key: reverb.key,
        wsHost: reverb.host,
        wsPort: reverb.port ?? 80,
        wssPort: reverb.port ?? 443,
        forceTLS: 'https' === (reverb.scheme ?? 'https'),
        enabledTransports: ['ws', 'wss'],
        encrypted: true,
        disableStats: true,
        authorizer: PusherAuth,
        Pusher,
    });
}

export function alderonEchoIsConfigured() {
    return 'undefined' !== typeof window && Boolean(window[ECHO_INSTANCE_KEY]);
}

export function alderonEcho() {
    return window[ECHO_INSTANCE_KEY];
}
